import React from "react";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";

export interface StakeholderPickerParty {
  key: string;
  label: string;
  /** Always included: shown on and cannot be turned off. */
  locked?: boolean;
}

interface StakeholderPickerProps {
  parties: readonly StakeholderPickerParty[];
  value: Readonly<Record<string, boolean>>;
  onToggle: (key: string, next: boolean) => void;
  disabled?: boolean;
  "aria-label"?: string;
}

/** Toggle chips for who gets an email; the send card and Settings share it. */
const StakeholderPicker: React.FC<StakeholderPickerProps> = ({
  parties,
  value,
  onToggle,
  disabled,
  "aria-label": ariaLabel,
}) => (
  <div className="flex flex-wrap gap-2" role="group" aria-label={ariaLabel}>
    {parties.map((party) => {
      const on = party.locked || Boolean(value[party.key]);
      return (
        <Button
          key={party.key}
          type="button"
          size="sm"
          variant={on ? "default" : "outline"}
          aria-pressed={on}
          // A locked chip is not `disabled`: that fades it as if off and drops its tooltip.
          disabled={disabled && !party.locked}
          aria-disabled={party.locked || undefined}
          className={party.locked ? "cursor-default" : undefined}
          title={party.locked ? `${party.label} always receives this email` : undefined}
          onClick={() => {
            if (!party.locked) onToggle(party.key, !on);
          }}
        >
          {party.locked && <Lock className="h-3 w-3" aria-hidden />}
          {party.label}
        </Button>
      );
    })}
  </div>
);

export default StakeholderPicker;
